<div class="popup-container">
  <div class="login-container">
    <div class="sign-in-container">
      <h2 class="title">Reset Password</h2>
      <div class="form" [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
        <div class="form-container">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput class="input" formControlName="email">
          </mat-form-field>
          <span class="error" *ngIf="resetForm && resetForm.controls['email'].hasError('required') && resetForm.touched">
            Please enter your email address
          </span>
          <span class="error"
            *ngIf=" resetForm && !resetForm.controls['email'].hasError('required') && resetForm.controls['email'].hasError('email') && resetForm.touched">
            Please enter your correct email address
          </span>
        </div>
  
        <!-- <div class="recaptch">
          <re-captcha
            (resolved)="onRecaptchaResolved($event)"
            (reset)="onCaptchaReset()"
            [siteKey]="recaptchaKey" 
          ></re-captcha>
        </div> -->
  
        <div class="form-button">
          <button type="submit" (click)="onResetSubmit()"><span class="btn-font" [hidden]="Showloader">Send reset link</span>
            <i [hidden]="!Showloader" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>